import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TimeLineItem from './TimeLineItem';
import {environment} from '../../../../containers/environment';
import { util } from "../../../../../src/shared/util";

class TimelineHistory extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      histories: []
    };
  }

  componentDidUpdate(prevProps) {
    if(prevProps.histories !== this.props.histories){
      this.setState({ histories: this.props.histories});
    }
  }

  render() {
    const { t } = this.props;

    let img = `${process.env.PUBLIC_URL}/img/`;
    let clientName = '';
    let qty = 0;
    let qtyMedida = '';
    let product = '';
    let activities = [];

    const total = this.state.histories.length;
    for(let i = 0; i < total; i++){//work, video, file, null
      qty = this.state.histories[i].qty;
      qtyMedida = this.state.histories[i].qtyMedida;

      if(qtyMedida === ""){
        if(this.state.histories[i].inUse){
          product = t('forms.machineUser_form_edit.startLease');
        }else{
          product = t('forms.machineUser_form_edit.endLease');
        }
        product = product + " (Cod. " + this.state.histories[i].code + ") ";
      }else{
        if(qtyMedida === "kg"){
          product = qty + ' ' + qtyMedida;
        }else{
          product = (qty > 1) ? qty + ' ' + qtyMedida + 's' : qty + ' ' + qtyMedida;
        }
      } 


      clientName = '';
      if(environment.isAdmin()){
        clientName = ' (' + 
          this.state.histories[i].firstName + ' ' + 
          this.state.histories[i].lastName + ')';
      }

      activities.push(
        <TimeLineItem 
          key={'timeLine' + this.state.histories[i].key} 
          type={this.state.histories[i].type}
          color={this.state.histories[i].color}
          img={img + "machine_branco.png"} 
          date={util.getDiff(this.state.histories[i].createdAt)}
          createdAt={util.formatDateHoraToString(this.state.histories[i].createdAt, "")}
          clientName={clientName}
          title={this.state.histories[i].name}>
          <p style={{fontSize: "12px"}}>
            {product}
            <br />
            {util.currencyMask(this.state.histories[i].price)}
          </p>
        </TimeLineItem>
      );
    }
  

    return (
      <div className="timeline">
        {activities}
      </div>
    );
  }
}

export default reduxForm({
  form: 'timeline_form', // a unique identifier for this form
})(withTranslation('common')(TimelineHistory));
